/**
 * @voltxampere/ui — IRF9540 PMOS power MOSFET variant (Sprint 38-2)
 *
 * Reference: Vishay/IRF IRF9540N datasheet (TO-220 power PMOS,
 * complement to IRF540).
 *   Vt0 = -4.0 V        (negative for PMOS, datasheet -2 to -4 V)
 *   Kp  = 11 A/V²
 *   Lambda = 0.01 1/V
 *
 * Power package: TO-220, R_th = 1.5 °C/W. Yaygın high-side switch.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { pmos } from "../pmos.js";
export const mosfetPmosIrf9540 = {
    id: "irf9540",
    nameTr: "IRF9540 (PMOS güç, TO220)",
    nameEn: "IRF9540 (PMOS power, TO220)",
    shortcut: "M",
    category: "active",
    viewBox: pmos.viewBox,
    terminals: pmos.terminals,
    defaultLabel: "M",
    defaultValue: "IRF9540",
    schemaType: "mosfet-pmos",
    defaultParams: { Vt0: -4.0, Kp: 11, Lambda: 0.01 },
    renderSVG: () => pmos.renderSVG(),
};
//# sourceMappingURL=mosfet-pmos-irf9540.js.map